var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _vm.title
        ? _c(
            "v-card",
            {
              staticClass: "mx-auto",
              attrs: { width: "100%", "aria-labelledby": "shop-section-title" },
            },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "heading landing-news-title",
                  attrs: { id: "shop-section-title" },
                },
                [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
              ),
              _vm._v(" "),
              _vm.description
                ? _c("v-card-subtitle", [
                    _vm._v("\n      " + _vm._s(_vm.description) + "\n    "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isLoading
                ? _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            lg12: "",
                            "my-2": "",
                            "full-width": "",
                            "align-middle": "",
                            "justify-middle": "",
                            "text-center": "",
                            column: "",
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "accent",
                              attrs: {
                                "aria-label": "See more from our shop",
                                role: "link",
                                large: "",
                                width: "100%",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.goTo(_vm.physicalShop)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "pr-2" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("components.goodsShop.seeMore")
                                    ) +
                                    "\n          "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-icon", [
                                _vm._v("fa-duotone fa-angles-right"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.title ? _c("v-divider") : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          class: {
            column: _vm.$vuetify.breakpoint.mdAndDown || _vm.isLoading,
            row: _vm.$vuetify.breakpoint.lgAndUp,
          },
          staticStyle: { width: "100%" },
          attrs: {
            "pl-4": "",
            "pr-4": "",
            "aria-busy": _vm.isLoading,
            role: "region",
            "aria-label": "Product collection",
          },
        },
        [
          !_vm.isLoading
            ? _c(
                "v-flex",
                {
                  staticClass: "mx-auto",
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg12: "",
                    justify: "center",
                    row: "",
                  },
                },
                _vm._l(_vm.collection, function (product) {
                  return _c(
                    "v-card",
                    {
                      key: product.id,
                      staticClass: "my-10",
                      attrs: {
                        "max-width": "374",
                        width: _vm.productWidth,
                        ripple: "",
                        role: "link",
                        tabindex: "0",
                        "aria-label":
                          "Product: " +
                          product.name +
                          ", Price: " +
                          product.price +
                          ", Category: " +
                          product.category,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.goTo(product.link)
                        },
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.goTo(product.link)
                        },
                      },
                    },
                    [
                      product.image
                        ? _c("v-img", {
                            attrs: {
                              height: "250",
                              src: product.image,
                              alt: product.name + " preview image",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-card-title", [_vm._v(_vm._s(product.name))]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _c("div", { staticClass: "my-4 text-subtitle-1" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(product.price) +
                              " • " +
                              _vm._s(product.category) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(product.description))]),
                      ]),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "mx-4" }),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-chip-group",
                            {
                              attrs: {
                                "active-class": "accent-4",
                                column: "",
                                "aria-label": "Product tags",
                              },
                            },
                            _vm._l(product.tags, function (tag) {
                              return _c(
                                "v-chip",
                                {
                                  key:
                                    tag + "-" + product.name.replace(/ /g, "-"),
                                  attrs: { "aria-label": "Tag: " + tag },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(tag) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoading
            ? _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg6: "",
                    "pt-8": "",
                    "pb-8": "",
                    "full-width": "",
                    "align-middle": "",
                    "justify-middle": "",
                    "text-center": "",
                    column: "",
                    role: "status",
                    "aria-live": "polite",
                    "aria-label": "Loading shop collection",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        large: "",
                        icon: "",
                        disabled: "",
                        "aria-hidden": "true",
                      },
                    },
                    [_c("v-icon", [_vm._v("fal fa-circle-notch fa-spin")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-2" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("components.loading")) +
                        "\n      "
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }